import React, { useState } from 'react';

import Link from './Link';

type Props = {
    message: string;
    value: string;
};

const HiddenText = ({ message, value }: Props) => {
    const [hidden, setHidden] = useState(true);

    if (hidden) {
        return <Link onClick={() => void setHidden(false)}>{message}</Link>;
    }

    return <div>{value}</div>;
};

export default HiddenText;
